import React from 'react';
import { useStore } from '../context/StoreContext';
import { MapPin } from 'lucide-react';

export const AnnouncementBar: React.FC = () => {
  const { pagesContent, t, language } = useStore();
  const { announcementBar } = pagesContent;

  if (!announcementBar.enabled) return null;

  const announcementDisplayText = language === 'ar' && (!announcementBar.text || announcementBar.text.includes('Sunday'))
    ? t.announcementDefault
    : announcementBar.text;

  return (
    <div id="announcement-bar" className="bg-[#111111] text-white border-b border-neutral-800 text-[11px] sm:text-xs font-semibold uppercase tracking-wider relative z-30">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2 flex items-center justify-between gap-4">
        {/* Left info */}
        <div className="hidden md:flex items-center gap-2 text-neutral-300 shrink-0">
          <MapPin className="w-3.5 h-3.5 text-[#E21B24]" />
          <span>{t.announcementLocation}</span>
        </div>

        {/* Center Marquee text */}
        <div className="flex-1 overflow-hidden whitespace-nowrap text-center">
          <div className="inline-block animate-marquee md:animate-none">
            <span className="text-[#E21B24] font-bold">⚡ {announcementDisplayText}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

